var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('div',{staticClass:"panel-overlay",on:{"click":_vm.closeOption}}):_vm._e()]),_c('transition',{attrs:{"name":`${_vm.forceBottomSheet ? 'bottom-sheet' : 'panel'}`}},[(_vm.value)?_c('div',{class:[
        _vm.forceBottomSheet ? 'panel bottom-sheet' : 'panel',
        _vm.extend ? 'extend' : '',
      ]},[_c('div',{staticClass:"panel__content"},[_vm._t("default")],2)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }